import CookieCutter from '@unisporkal/cookie-cutter';
import {
  SEARCH_PREFERENCE_FIELD_CODES,
  type SearchPreferencesDTO,
} from 'app/domain';

/**
 * The `sp` cookie, defined once for both sides.
 *
 * CookieCutter is isomorphic: `cookieProviderResolver` returns a browser store
 * when `document` exists and a server store otherwise, so the definition itself
 * is side-agnostic and only the `find()` call differs —
 *
 *   SearchPreferenceCookie.find()                        // browser
 *   SearchPreferenceCookie.find(req.cookieCutterCookies) // server
 *
 * The field map (`SEARCH_PREFERENCE_FIELD_CODES`) lives in the domain; only
 * the store binding lives here. A future BFF reader binds the same map in its
 * own layer rather than importing this file.
 */
const SearchPreferenceCookie = CookieCutter.define<SearchPreferencesDTO>({
  name: 'sp',
  options: {
    maxAgeYears: 1,
  },
  values: SEARCH_PREFERENCE_FIELD_CODES,
});

export { SearchPreferenceCookie };
